import { Link, useNavigate, useParams } from "react-router-dom";
import {
  Panel,
  PanelHeader,
  PanelBody,
} from "./../../components/panel/panel.jsx";
import { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Select from "react-select";
import DropDownStyles from "./dropdownStyles.js";
import axiosInstance from "../../config/axiosApi/axiosApi.jsx";
import StaffTabBar from "./staffTabBar.js";
import APIs from "../../Constants/apis.js";
import Preloader from "../../components/CustomComponents/preLoad/preLoader.js";
import showErrorToast, {
  showSuccessToast,
} from "../../components/CustomComponents/toast/toast.js";
import FormInput from "../../components/CustomComponents/Input/formInput.jsx";
import ToggleSwitch from "../../components/CustomComponents/Switchery/switchery.jsx";
import "react-datetime/css/react-datetime.css";

function UpdateStaff() {
  const { UserName } = useParams();
  const navigatore = useNavigate();
  const CompID = useSelector((state) => state.auth.user).userData?.compID;
  const [roles, setRoles] = useState([]);
  const [countries, setCountries] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState({});
  const [selectedRole, setSelectedRole] = useState({});
  const [staffData, setStaffData] = useState({
    userName: "",
    firstName: "",
    lastName: "",
    email: "",
    country: "UK",
    phoneNo: "",
    passCode: "",
    ratePerHour: 0,
    active: false,
    userRoles: null,
  });
  const FetchRoles = useCallback(async () => {
    try {
      setLoading(true);
      const response = await axiosInstance.get(
        APIs.GET_ROLES + `?CompID=${CompID}`
      );
      const roleData = response.data.data || response.data;
      const rolesOptions = roleData.map((role) => ({
        value: role.comRolePermission_ID,
        label: role.r_Title,
      }));
      setRoles(rolesOptions);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  }, [CompID]);

  const FetchCountries = useCallback(async () => {
    try {
      setLoading(true);
      const response = await axiosInstance.get(APIs.GET_COUNTRIES);
      const roleData = response.data.data || response.data;
      const mappedOptions = roleData.map((country) => ({
        value: country.code,
        label: country.name,
      }));
      setCountries(mappedOptions);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  }, []);

 

  const FetchStaffData = useCallback(async () => {
    try {
      setLoading(true);
      const response = await axiosInstance.get(APIs.GET_STAFF_DATA, {
        params: {
          CompID,
          UserName,
        },
      });
      const staff = response.data.data || response.data;

      setSelectedCountry(countries.find((c) => c.value === staff.country));
      setSelectedRole(roles.find((r) => r.value === staff.comRolePermission_ID));
       
      setStaffData({
        ...staff,
      });

    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  }, [CompID, UserName, countries, roles]);

  useEffect(() => {
    const fetchData = async () => {
      await Promise.all([FetchRoles(), FetchCountries()]);
    };

    fetchData();

  }, [FetchRoles, FetchCountries]);

  useEffect(() => {
    if (countries.length > 0 && roles.length > 0) {
      FetchStaffData();
    }
  }, [countries, roles, FetchStaffData]);

  const handleSubmit = async () => {
    const {
      userName,
      firstName,
      lastName,
      email,
      country,
      passCode,
      phoneNo,
      ratePerHour,
      active,
    } = staffData;
  
    if (
      !userName ||
      !firstName ||
      !lastName ||
      !email ||
      !country ||
      !passCode
    ) {
      showErrorToast("Please fill in all required staff fields.");
      return;
    }
  
    try {
      setLoading(true);
      await axiosInstance.put(APIs.UPDATE_STAFF, {
        UserName: userName,
        FirstName: firstName,
        LastName: lastName,
        Email: email,
        Country: country,
        PhoneNo: phoneNo,
        PassCode: passCode,
        RatePerHour: ratePerHour,
        Active: active,
        Password: "",
        CompID: CompID,
        ComRolePermission_ID: selectedRole.value,
      });
  
      setLoading(false);
      showSuccessToast("Staff updated successfully!");
      navigatore("/staff/manageStaff");
    } catch (error) {
      setLoading(false);
      console.error(error);
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        showErrorToast(error.response.data.message);
      } else {
        showErrorToast("Failed to update staff.");
      }
    }
  };

  return (
    <div>
      {loading && <Preloader />}
      <div className="d-flex align-items-center mb-2 mt-2">
        <div>
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to="/">Home</Link>
            </li>
            <li className="breadcrumb-item">
              <Link to="/staff/manageStaff">Manage Staff</Link>
            </li>
            <li className="breadcrumb-item active">Update Staff</li>
          </ol>
          <h1 className="page-header mb-0">
            Update Staff – {[staffData.firstName, staffData.lastName].filter(Boolean).join(" ").trim() || UserName} ({UserName})
          </h1>
        </div>
        <div className="ms-auto">
          <button
            onClick={handleSubmit}
            className="btn btn-success btn-rounded px-4 rounded-pill"
          >
            <i className="fa-lg me-2 ms-n2 text-success-900"></i>
            Submit
          </button>
        </div>
      </div>
      <div className="card border-0">
        <StaffTabBar
          activeTab="updateInfo"
          useTab="false"
          UserName={UserName}
        />
        {/* Staff Information Section */}
        <Panel className="m-3">
          <PanelHeader>Staff Information</PanelHeader>
          <PanelBody>
            <div className="row mb-3">
              <div className="col-6">
                <FormInput
                  label="User Name"
                  placeHolder="Enter User Name"
                  type="text"
                  value={staffData.userName}
                  readOnly={true}
                  onchange={(e) =>
                    setStaffData({ ...staffData, userName: e.target.value })
                  }
                />
              </div>
              <div className="col-6">
                <FormInput
                  label="First Name"
                  placeHolder="Enter First Name"
                  type="text"
                  value={staffData.firstName}
                  onchange={(e) =>
                    setStaffData({ ...staffData, firstName: e.target.value })
                  }
                />
              </div>
            </div>
            <div className="row mb-3">
              <div className="col-6">
                <FormInput
                  label="Last Name"
                  placeHolder="Enter Last Name"
                  type="text"
                  value={staffData.lastName}
                  onchange={(e) =>
                    setStaffData({ ...staffData, lastName: e.target.value })
                  }
                />
              </div>
              <div className="col-6">
                <FormInput
                  label="Email"
                  placeHolder="Enter Email"
                  type="email"
                  value={staffData.email}
                  onchange={(e) =>
                    setStaffData({ ...staffData, email: e.target.value })
                  }
                />
              </div>
            </div>
            <div className="row mb-3">
              <div className="col-6">
                <label>Country</label>
                <Select
                  value={selectedCountry}
                  onChange={(option) => {
                    setSelectedCountry(option);
                    setStaffData({ ...staffData, country: option.value });
                  }}
                  options={countries}
                  styles={DropDownStyles}
                />
              </div>
              <div className="col-6">
                <label>User Roles</label>
                <Select
                  value={selectedRole}
                  onChange={(option) => {
                    setSelectedRole(option);
                    setStaffData({ ...staffData, userRoles: option.value });
                  }}
                  options={roles}
                  styles={DropDownStyles}
                />
              </div>
            </div>
            <div className="row mb-3">
              <div className="col-6">
                <FormInput
                  label="Phone Number"
                  placeHolder="Enter Phone Number"
                  type="text"
                  value={staffData.phoneNo}
                  onchange={(e) =>
                    setStaffData({ ...staffData, phoneNo: e.target.value })
                  }
                />
              </div>
              <div className="col-6">
                <FormInput
                  label="Pass Code"
                  placeHolder="Enter Pass Code"
                  type="text"
                  value={staffData.passCode}
                  onchange={(e) =>
                    setStaffData({ ...staffData, passCode: e.target.value })
                  }
                />
              </div>
            </div>
            <div className="row mb-3">
              <div className="col-6">
                <FormInput
                  label="Rate Per Hour"
                  placeHolder="Enter Rate Per Hour"
                  type="text"
                  value={staffData.ratePerHour}
                  onchange={(e) =>
                    setStaffData({
                      ...staffData,
                      ratePerHour: e.target.value,
                    })
                  }
                />
              </div>
            </div>
            <div className=" col-3 me-4">
              <ToggleSwitch
                isChecked={staffData.active}
                onToggle={(e) =>
                  setStaffData({ ...staffData, active: e.target.checked })
                }
                label="Active"
                name="active"
              />
            </div>

          </PanelBody>
        </Panel>
      </div>
    </div>
  );
}

export default UpdateStaff;
